import { formatAddressField } from './filterUtils';

/**
 * Reusable City / State / Zip column definitions.
 * @param {object} options
 * @param {function} options.t - i18n translate (optional)
 * @param {string} options.prefix - field prefix e.g. 'address' | 'contact.address'
 * @param {object} options.labels - { city, state, zip }
 * @param {string[]} options.keys - subset of ['city','state','zip'] (default all three)
 */
export const getAddressColumns = ({
  t,
  prefix = 'address',
  labels = {},
  keys = ['city', 'state', 'zip'],
} = {}) => {
  const cityLabel = labels.city || (t ? t('Location.City') : 'City');
  const stateLabel = labels.state || (t ? t('Location.State') : 'State');
  const zipLabel = labels.zip || (t ? t('Location.Zip') : 'Zip');

  const getNested = (data, path) => {
    if (!data) return '';
    return path.split('.').reduce((acc, key) => (acc && acc[key] != null ? acc[key] : null), data);
  };

  const all = {
    city: {
      headerName: cityLabel,
      field: `${prefix}.city`,
      colId: `${prefix}.city`,
      valueGetter: (params) =>
        formatAddressField(getNested(params.data, `${prefix}.city`)),
    },
    state: {
      headerName: stateLabel,
      field: `${prefix}.state`,
      colId: `${prefix}.state`,
      valueGetter: (params) =>
        formatAddressField(getNested(params.data, `${prefix}.state`)),
    },
    zip: {
      headerName: zipLabel,
      field: `${prefix}.zip`,
      colId: `${prefix}.zip`,
      valueGetter: (params) =>
        formatAddressField(getNested(params.data, `${prefix}.zip`)),
    },
  };

  return (keys || []).map((key) => all[key]).filter(Boolean);
};

export default getAddressColumns;



// WEBPACK FOOTER //
// ./src/components/grid/addressColumns.js